import { render, staticRenderFns } from "./ServicesTypes.vue?vue&type=template&id=ea48829a&"
import script from "./ServicesTypes.vue?vue&type=script&lang=js&"
export * from "./ServicesTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports